import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiEye, FiLock, FiShare2, FiUserCheck, FiRefreshCw, FiMail } from "react-icons/fi";

const Privacypolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex flex-col relative overflow-hidden">
      {/* Decorative Blur (Matching Sell Product & Terms) */}
      <div className="absolute top-[-5%] right-[-10%] w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-40"></div>

      {/* Unified Header */}
      <div className="bg-white px-6 py-6 flex items-center shadow-sm border-b border-gray-100 relative z-20">
        <button 
          onClick={() => navigate(-1)} 
          className="p-2 -ml-2 hover:bg-gray-100 rounded-full transition text-gray-900"
        >
          <IoMdArrowBack size={24} />
        </button>
        <div className="ml-4">
          <h1 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-600">Compliance</h1>
          <p className="text-xl font-black text-gray-900 tracking-tighter">Privacy Policy</p>
        </div>
      </div>

      {/* Content Container */}
      <div className="flex-1 p-4 max-w-2xl mx-auto w-full relative z-10 pt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-6 md:p-10 shadow-xl shadow-gray-200/50 border border-gray-100 space-y-10">
          
          <div className="space-y-4">
            <p className="text-sm font-bold text-gray-600 leading-relaxed">
              At <span className="text-orange-600 font-black">OurASAP</span>, we value your privacy. This policy explains how we collect, use, and safeguard your data to provide a seamless marketplace experience.
            </p>
          </div>

          {/* Section 1: Information We Collect */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiUserCheck size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">1. Information Collection</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              We collect personal information such as your name, email, phone number, and delivery addresses when you register or list a product.
            </p>
          </div>

          {/* Section 2: Usage */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiEye size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">2. How We Use Data</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              Your information helps us process orders, verify sellers, and improve platform security to prevent fraudulent listings.
            </p>
          </div>

          {/* Section 3: Sharing */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiShare2 size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">3. Information Sharing</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              We do not sell your personal data. Data is only shared with trusted partners (like logistics) to fulfill your specific requests.
            </p>
          </div>


 




          {/* Section 4: Security */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiLock size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">4. Data Security</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              We use industry-standard encryption to protect your account. While no system is 100% secure, we continuously update our protocols.
            </p>
          </div>

          {/* Section 5: Updates */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiRefreshCw size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">5. Policy Updates</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
              We may update this policy periodically. Your continued use of OurASAP after changes signifies your agreement to the new terms.
            </p>
          </div>
              <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiRefreshCw size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">6. Email Communications</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
            OurASAP sends emails related to your account and activities on our platform, including account verification, password recovery, order updates, seller notifications, delivery updates, and important service announcements. We do not use email addresses collected from users for unsolicited spam or unauthorized promotional messaging. Every User have the unsubscribe button to any email relating to OurASAP  </p>
          </div>



      <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiRefreshCw size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">7. User Consent</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
By creating an account on OurASAP, users agree to receive necessary service-related communications required to operate their account and complete transactions. </p>
          </div>


      <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center text-orange-600">
                <FiRefreshCw size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">8. Account deletion/data requests</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold leading-relaxed ml-10">
Users may request deletion of their account or personal information by contacting our support email. </p>
          </div>






          {/* Contact Section */}
          <div className="pt-6 border-t border-gray-100 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gray-900 rounded-lg flex items-center justify-center text-white">
                <FiMail size={16} />
              </div>
              <h3 className="text-[11px] font-black uppercase tracking-widest text-gray-900">Privacy Support</h3>
            </div>
            <p className="text-sm text-gray-600 font-bold ml-10">
              For data requests or privacy concerns, reach out to: <br />
              <span className="text-orange-600">ourasapservice@gmail.com</span>
            </p>
          </div>

          {/* Footer */}
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest text-center pt-4">
            &copy; {new Date().getFullYear()} OurASAP. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacypolicy;